module.exports = __webpack_public_path__ + "static/guaranteedservice-52b4e90aea366f850a4afae3188104c4.png";